// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__HuMMF","title":"styles_title__HAbMo","properties":"styles_properties__I0iu4","property":"styles_property__z90_Y","value":"styles_value__wBcSc"};